/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Box, MenuItem, Select, Tooltip } from '@material-ui/core'
import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { HelpCircle } from 'react-feather'
import { useTranslation } from 'react-i18next'
import MaskedInput from 'react-text-mask'

import VerifiedSymbol from '../../assets/images/symbols_verified.png'
import { NUMBER_SYMBOLS, UsPhoneCode } from '../../helpers/constants'
import { noop } from '../../helpers/utils'

export default function PhoneInput334({
  id,
  name,
  phonePrefix,
  setFieldValue,
  countries,
  tooltipTitle,
  prefixName,
  disabled,
  mobileVerified,
  mask,
}) {
  const phoneNumberMask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  const { t } = useTranslation()

  const onCountryChange = (e) => {
    if (!mask) {
      setFieldValue(name, '')
    }
    setFieldValue(prefixName, e.target.value)
  }

  return (
    <Box className="custom-phone-field">
      <Select
        labelId="country-code-label"
        value={phonePrefix}
        onChange={(e) => onCountryChange(e)}
        id="country-menu"
        classes={{ root: 'country-list' }}
        className="no-underline"
        inputProps={{
          'aria-label': 'Without label',
        }}
        disabled={disabled}
      >
        {countries?.map((country) => (
          <MenuItem value={country.phoneCode} key={country.id} className="country">
            <span className={`country-flag ${country.isoCode.toLowerCase()}`}></span>
            <span className="country-name">{country.name}</span>
            <span className="dial-code">{`${country.phoneCode}`}</span>
          </MenuItem>
        ))}
      </Select>
      {mask || phonePrefix === UsPhoneCode ? (
        <Field
          className="phone-input"
          as={MaskedInput}
          type="text"
          mask={phoneNumberMask}
          id={id}
          name={name}
          fullWidth
          variant="outlined"
          size="small"
          onChange={(e) => {
            setFieldValue(e.target.name, e.target.value)
          }}
          disabled={disabled}
        />
      ) : (
        <Field
          className="phone-input"
          type="number"
          id={id}
          name={name}
          fullWidth
          variant="outlined"
          size="small"
          onChange={(e) => {
            if (e.target.value.length < 16) {
              setFieldValue(e.target.name, e.target.value)
            } else {
              e.preventDefault()
            }
          }}
          onWheel={(event) => event.target.blur()}
          onKeyDown={(e) => NUMBER_SYMBOLS.includes(e.key) && e.preventDefault()}
          disabled={disabled}
        />
      )}

      <Box position="absolute" right="13px" top="10px">
        {mobileVerified && disabled ? (
          <Tooltip title={t('mobileNumberVerified')} placement="top">
            <img src={VerifiedSymbol} alt={t('mobileNumberVerified')} />
          </Tooltip>
        ) : (
          <Tooltip title={t(tooltipTitle)} placement="top">
            <HelpCircle className="help-icon" />
          </Tooltip>
        )}
        {/**/}
      </Box>
    </Box>
  )
}
PhoneInput334.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  phoneNum: PropTypes.string,
  phonePrefix: PropTypes.string,
  setFieldValue: PropTypes.func,
  countries: PropTypes.array,
  tooltipTitle: PropTypes.string,
  prefixName: PropTypes.string,
  disabled: PropTypes.bool,
  mobileVerified: PropTypes.bool,
  mask: PropTypes.bool,
}
PhoneInput334.defaultProps = {
  id: '',
  name: '',
  phoneNum: '',
  phonePrefix: '',
  setFieldValue: noop,
  countries: [],
  tooltipTitle: '',
  prefixName: '',
  disabled: false,
  mobileVerified: false,
  mask: true,
}
